<template>
	<div class>
		<ModalBox v-model="legacyModalVisible" placement="right" size="sm" scroll-body hide-close header-class="!hidden">

			<div class="modal-container">
				<div class="mt-100 px-3 mobile-header flex flex-wrap items-start">
					<div class="lg:mt-3 w-5/6 lg:w-2/3">
						<router-link :to="{ path: '/dashboard' }" class="modal-logo hidden lg:block">
							<img height="32px" class="logo-icon" :src="require('@/assets/castr.svg')" alt="Streaming Dashboard - Castr"   />
							<div class="logo-icon-dot" />
						</router-link>
						<h3 class="modal-title lg:hidden m-0">New transcoder</h3>
					</div>
					<div class="mt-3 text-right w-1/6 lg:w-1/3">
						<FormButton type="light" :isIcon="true" class="px-2" @click="closeModal">
							<img :src="require('@/assets/images/menu-close.svg')" alt="Menu close">
						</FormButton>
					</div>
				</div>
				<div class="mt-4 px-3 flex flex-wrap">
					<div class="w-full">
						<h3 class="text-s-l text-500 hidden lg:block modal-title-style2 px-0">New transcoder</h3>
						<p class="text-dark-8 mb-4 text-s-s">
							Seamlessly modify codecs and bitrates with new transcoding profile
						</p>
						<Alert v-if="error" type="error" class="flex items-start">
							
								<p class="text-s-m text-500 mb-0" v-if="error.message === 'stream name already in use'">Stream name already in use</p>
								<template v-else>
									<div>
										<p class="text-sm font-medium mb-0">You don't have enough quota</p>
									<p class="text-tiny mb-0">Please contact <span class="underline cursor-pointer" onclick="Intercom('show')">sales</span> team to get more Transcoders.</p>
									</div>
								</template>
							
						</Alert>
					</div>
				</div>
				<div class="px-3 flex flex-wrap">
					<div class="w-full">
						<label class="text-s-s">
						    Transcoder name
						</label>

						<FormInput v-model="transcoderName" class="input" placeholder="Enter a name" />
					</div>
				</div>
				<div class="px-3 mt-3 flex flex-wrap">
					<div
						class="w-full"
						v-show="(contextualRegionList.length > 0 && selectedStreamType === 'live' ) || contextualRegionList.length > 1"
					>
						<label class="text-s-s w-full">
							Ingest Location
						</label>
						<StreamRegion class="relative" :stream="newStreamComputed" @switch-stream-region="selectRegion" />
						<p
							v-show="formErrors.region"
							class="text-warning pl-1"
						>
							specify hosting region
						</p>
					</div>
				</div>
				<div class="px-3 flex flex-wrap">
					<div class="w-full">
						<div>
							<div class="text-center">
								<FormButton
									:isLoading="processing"
									:disabled="transcoderName.length === 0 || !selectedRegion"
									label="Create Transcoder"
									@click="onConfirm"
									type="main"
									size="md"
									fullWidth
									class="justify-center mt-4 mb-4 lg:mb-0"
								/>
								<div class="mt-2">
									<FormButton type="secondary" size="md" fullWidth class="justify-center mb-3 md:mb-0"
										@click="closeModal">
										Cancel
									</FormButton>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		
</ModalBox>
	</div>
</template>

<script>
import ModalBox from '@/components/modals/ModalBox.vue'
import { legacyModalBridgeMixin } from '@/composables/useLegacyModalBridge'
import _ from 'lodash';
import TranscoderService from '@/services/TranscoderService';
import StreamService from '@/services/StreamService'; 
import StreamRegion from '../ui/StreamRegion.vue';
import FormButton from '@/components/Atoms/FormButton.vue';
import Alert from '@/components/Atoms/Alert.vue';
import FormInput from '@/components/Atoms/FormInput.vue';
import { track, EVENTS } from '@/lib/tracking';

export default {
	name: 'AddTranscoderModal',
	mixins: [legacyModalBridgeMixin],
	legacyModalId: 'modal-add-transcoder',
	components: {
		ModalBox,
		FormButton,
		StreamRegion,
		Alert,
		FormInput,
	},
	data() {
		return {
			transcoderName: '',
			processing: false,
			error: null,
			selectedRegion: null,
			regions: [],
			selectedStreamType: 'live',
			channel: {
				name: null,
				region: null
			},
			formErrors: { name: false, region: false },
			onInputChange(prop) {
				this.formErrors[prop] = false;
			}
		};
	},
	computed: {
		newStreamComputed() {
			const newStream = {}
			newStream.uiRegion = this.selectedRegion
			newStream.type = 'live'
			return newStream
		},
		contextualRegionList() {
			const stype = this.selectedStreamType;
			// we don't ask scheduled region from user
			if (stype === 'scheduled') {
				return [];
			}

			return stype
				? this.regions.filter(r => r.platforms.indexOf('restream') > -1)
				: [];
		},
	},
	async mounted() {
		// Use Vuex store for regions (already loaded at app level)
		await this.$store.dispatch('Regions/getRegions', 'list');
		this.regions = _.cloneDeep(this.$store.getters['Regions/getRegionsByCategory']('list'));
	},
	methods: {
		// was @hidden="onReset" on the old b-modal
		onLegacyModalHidden() {
			this.onReset();
		},
		selectRegion(region) {
			this.selectedRegion = region;
			this.channel.region = region._id;
			this.onInputChange('region');
		},
		async onConfirm() {
			if (this.processing) return;
			this.processing = true;
			try {
				const newTranscoder = await TranscoderService.createTranscoder(
					this.transcoderName,
					this.selectedRegion._id
				)
				track(EVENTS.TRANSCODER_CREATED, {
					transcoderId: newTranscoder?._id,
					regionName: this.selectedRegion?.name,
				})
				this.$emit('transcoder-added', newTranscoder)
				this.closeModal()
			} catch (err) {
				console.error(err)
				this.error = err
				this.selectedRegion = null
			}
			this.processing = false;
		},
		closeModal() {
			this.transcoderName = ''
			this.hideLegacyModal()
		},
		onReset() {
			this.error = null
			this.channel.name = null;
			this.selectedRegion = null;
		}
	}
};
</script>

<style scoped>
@media (max-width: 767px) {
	.mobile-header {
		border-radius: 24px 24px 0 0;
		margin-top: 0;
		background-color: var(--c-dark-3);
	}
	.modal-title {
    padding: 16px 0;
	}
}
</style>